module.exports = __webpack_public_path__ + "img/Biologia II.b2d9ea8c.png";